module.exports = __webpack_public_path__ + "img/gold.28eda6e3.svg";